export default class ReservaController {
  constructor(axiosHandler, passporthandler) {
    this.axiosHandler = axiosHandler
    this.passporthandler = passporthandler
  }
  async procesar(usuarioWeb, form, servicios) {
    this.usuarioWeb = usuarioWeb
    this.form = form
    this.servicios = servicios
    var mensaje = this.armarRq()
    await this.reservar(mensaje)
  }
  armarRq() {
    var pagador = this.armarPagador(
      this.form.agencia.id,
      this.form.agencia.nombre,
      this.form.agencia.cuit,
      this.form.genero
    )
    var mensaje = {
      usuarioweb: this.usuarioWeb,
      servicios: this.servicios,
      pagador: pagador,
      nroFile: this.form.nfile
    }
    return mensaje
  }
  armarPagador(id, nombre, cuil, genero) {
    const idgenero = this.usuarioWeb != undefined ? 3 : genero
    return { id: id, nombre: nombre, cuil: cuil, genero: idgenero }
  }
  async reservar(mensaje) {
    var header = this.passporthandler.prepareHeader()
    var url = process.env.VUE_APP_ASBACK + "/api/reservar"
    this.axiosHandler.prepare(url, header, mensaje)
    await this.axiosHandler.exe()
    this.rs = this.axiosHandler.getData()
  }
  getRs() {
    return this.rs
  }
  async saveReserva(mensaje) {
    var header = this.passporthandler.prepareHeader()
    var url = process.env.VUE_APP_ASBACK + "/api/json-mensaje"
    this.axiosHandler.prepare(url, header, mensaje)
    await this.axiosHandler.exe()
    this.rs = this.axiosHandler.getData()
  }
}
